module.exports = __webpack_public_path__ + "static/img/03.c174682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news22/03.png
// module id = NIli
// module chunks = 1